/**
 * Deletes empty get parameters from GET submitted <form> URLs for cleaner user
 * experience (sharing URLs, etc).
 */
export default class GetFormHandler {
    constructor() {
        document.addEventListener('turbo:submit-start', this._cleanGetParams);
    }

    _cleanGetParams = (event) => {
        if (!event.detail
            || !event.detail.formSubmission
        ) {
            return;
        }

        const formSubmission = event.detail.formSubmission;
        const request        = formSubmission.fetchRequest;
        const location       = formSubmission.location;

        if (!request
            || !location
            // method 0 == GET, but cannot import Turbo's "FetchMethod" here for some reason
            || request.method !== 0
            || !formSubmission.formElement
        ) {
            return;
        }

        const toDelete = [];
        for (const [key, value] of location.searchParams.entries()) {
            if (value === '' || value === null) {
                // cannot delete while iterating entries()
                toDelete.push(key);
            }
        }

        for (const key of toDelete) {
            location.searchParams.delete(key);
        }
    };
}
